// Module
var code = "<div> <div> <strong>{{labelOne}}</strong>: {{statusLabel}} </div> <div> <strong>{{labelTwo}}</strong>: {{timeElapsed}} {{timeUnit}} </div> <div> <strong>{{success ? '' : labelThree + ':'}}</strong> {{message}} </div> </div> ";
// Exports
var _module_exports =code;;
var path = '/components-superadmin/mail/mail-test-response-tooltip.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;